import { Fragment } from 'react'
import BlockRenderer from '@/components/ChatResponseElements/BlockRenderer'
import { cleanPhase1TextForArtifacts } from './phase1ContentDisplay'
import Phase1ResponseText from './Phase1ResponseText'
import { lastMarkdownPartIndex } from './lastMarkdownPartIndex'

function partKey(part, index) {
  return part.review_id ?? `${part.type}-${part.attempt_id ?? 'none'}-${index}`
}

export default function Phase1InlineResponseParts({ parts, citations, streaming, animateEnter }) {
  const lastText = lastMarkdownPartIndex(parts)
  return parts.map((part, index) => {
    if (part.type === 'markdown') {
      const text = cleanPhase1TextForArtifacts(part.text, true, false)
      return text ? (
        <Phase1ResponseText
          key={partKey(part, index)}
          text={text}
          citations={citations}
          streaming={Boolean(streaming && index === lastText)}
        />
      ) : null
    }
    if (part.type === 'integration_access_request') {
      return (
        <BlockRenderer
          key={partKey(part, index)}
          blocks={[part]}
          citations={citations}
          streaming={streaming}
          animateEnter={animateEnter}
        />
      )
    }
    return <Fragment key={partKey(part, index)} />
  })
}
